// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("/Users/fredericksilva/Downloads/aranhaagency.github.io/src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-contact-index-js": function componentSrcPagesContactIndexJs() {
    return import("/Users/fredericksilva/Downloads/aranhaagency.github.io/src/pages/contact/index.js"
    /* webpackChunkName: "component---src-pages-contact-index-js" */
    );
  },
  "component---src-pages-contact-thanks-js": function componentSrcPagesContactThanksJs() {
    return import("/Users/fredericksilva/Downloads/aranhaagency.github.io/src/pages/contact/thanks.js"
    /* webpackChunkName: "component---src-pages-contact-thanks-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("/Users/fredericksilva/Downloads/aranhaagency.github.io/src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-page-2-js": function componentSrcPagesPage2Js() {
    return import("/Users/fredericksilva/Downloads/aranhaagency.github.io/src/pages/page-2.js"
    /* webpackChunkName: "component---src-pages-page-2-js" */
    );
  }
};